<template>
  <div class="fts-automation-scoped-variables">
    <div class="variable-header">Variables</div>
    <div
      v-for="variable in variables"
      :key="variable.name"
      class="variable-item"
    >
      {{ variable.name }}
      <span style="font-size: smaller; color: gray"
        >Node:{{ variable.nodeId }}
      </span> <span>{{variable.activityId}}</span>
      <fts-label-group
        :item="getModule(variable.moduleId)"
        emoji
        :emoji-size="12"
        class="console-element-tag"
        v-if="variable.moduleId"
      />
    </div>
  </div>
</template>

<script>
import { automationDesignStore } from "../../store/automationDesignStore";
import FTSLabelGroup from "../../elements/display/FTSLabelGroup";

export default {
  props: {
    variables: Array,
  },
  components: {
    "fts-label-group": FTSLabelGroup,
  },
  methods: {
    getModule(id) {
      if (id && this.$store.getters.workspaceModules) {
        const findModule = this.$store.getters.workspaceModules.find(
          (x) => x.id == id
        );
        if (findModule)
          return {
            id: findModule.id,
            name: findModule.name,
            emoji: findModule.emoji,
          };
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-automation-scoped-variables {
  border: 1px solid $grayLightColor;
  border-radius: 0.25rem;
  background: #fff;
  .variable-header {
    padding: 0.3rem 0.5rem;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    background: #eee;
  }
  .variable-item {
    padding: 0.3rem 0.5rem 0;
    &:last-child {
      padding-bottom: 0.3rem;
    }
  }
}
</style>
